import { useEffect } from 'react';

export default function Toast({ message, onDone }) {
  useEffect(() => {
    if (!message) return;
    const t = setTimeout(() => onDone(), 2500);
    return () => clearTimeout(t);
  }, [message, onDone]);

  return (
    <div className={`toast${message ? ' show' : ''}`}>
      {message}
    </div>
  );
}
